import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";

export const getContentArea = (
  pageSize = 999,
  pageNumber = 1,
  ColumnName = "Name",
  SortDir = "asc",
  contentAreaId = 0,
  name = "",
  abbreviation = ""
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_CONTENT_AREA_ALL, {
    params: {
      PageSize: pageSize,
      PageNumber: pageNumber,
      OrderByColumn: ColumnName,
      SortDir: SortDir,
      contentAreaId: contentAreaId,
      name: name,
      abbreviation: abbreviation,
    },
  });
};

export const postContentArea = (postContentData) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_CONTENT_AREA_ALL,
    postContentData,
    {}
  );
};
export const deleteContentArea = (contentAreaId) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_CONTENT_AREA, {
    params: {
      id: contentAreaId,
    },
  });
};
export const updateContentArea = (updatecontentData) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_CONTENT_AREA_ALL,
    updatecontentData,
    {}
  );
};

export const getContentAreaById = (id) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_CONTENT_AREA}/${id}`
  );
};

export const getIconPreviewURL = (fileName: string, subDirectory: string) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_ICON_PREVIEW, {
    params: { iconFileName: fileName, subDirectory: subDirectory },
  });
};
